(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-ymm-custom"]) return;
  try {
    
  // Move all your logic into a function
  function processProducts() {
    let num_platinum = 0,
      num_shade_blue = 0,
      num_shade_green = 0,
      num_shade_orange = 0,
      num_shade_pink = 0,
      num_shade_red = 0,
      num_shade_white = 0,
      num_black_edition = 0,
      num_rear = 0,
      num_heavy = 0,
      low_platinum = 0,
      low_shade_blue = 0,
      low_shade_green = 0,
      low_shade_orange = 0,
      low_shade_pink = 0,
      low_shade_red = 0,
      low_shade_white = 0,
      low_black_edition = 0,
      low_heavy = 0;

    const resultsContainer = document.querySelector('#results_container');
    const productContainer = document.querySelector('#product_container');

    // Check if products have actually loaded
    const products = productContainer.querySelectorAll('.grid__item');
    if (products.length === 0) {
      console.log('No products found yet, waiting...');
      return false; // Indicate processing failed
    }

    // Process thumbnail resolution increase
    productContainer.querySelectorAll('.grid-view-item__image').forEach(img => {
      img.src = img.src.replace(/_\d+x\d+(\.\w+)$/, '_600x600$1');
    });

    console.log(`Processing ${products.length} products`);

    function htmlToElem(html) {
      let temp = document.createElement('template');
      html = html.trim();
      temp.innerHTML = html;
      return temp.content.firstChild;
    }

    function renderAddToCart(product) {
      if (product.dataset.prdStatus != 0) {
        return htmlToElem(`
          <div>
            <div class="mt-2.5 relative z-20">
              <form
                id="add-to-cart-${product.id}"
                data-ymm-add-to-cart
                method="post"
                action="/cart/add"
                accept-charset="UTF-8"
                class="quick-buy-product-form"
                enctype="multipart/form-data"
                data-product-form=""
                data-product-handle=""
                data-enable-history-state="true"
              >
                <input type="hidden" name="form_type" value="product" /><input
                  type="hidden"
                  name="utf8"
                  value="✓"
                />
                <input type="hidden" name="id" value="${product.dataset.firstVarId}" />

                <div class="relative z-10 text-center pb-button-shadow">
                  <button class="push-btn theme-button w-full" type="submit">
                    <span class="push-btn-surface w-full"> Add to Cart </span>
                  </button>
                </div>
              </form>
            </div>
          </div>      
          `);
      } else {
        return htmlToElem(`
          <div>
            <div class="mt-2.5 relative z-20">
              <div class="relative z-10 text-center cursor-not-allowed pb-button-shadow">
                <button class="btn text-sm lg:text-base after:hidden bg-scheme-background text-scheme-text shadow-secondary w-full" type="submit" disabled="disabled">
                  <span class=" w-full">
                    Sold Out
                  </span></button>
              </div>
            </div>
          </div>
        `);
      }
    }

    function handleAddToCart(evt) {
      evt.preventDefault();
      console.log(window.theme.settings.cart_type);
      this.loading = true;

      liveRegion(window.theme.strings.loading);
      const formData = new FormData(evt.currentTarget);
      let modalCart = window.theme.settings.cart_type === 'modal';
      const config = fetchConfigDefaults('javascript');

      if (modalCart) {
        formData.append('sections', 'cart-items,cart-footer,cart-item-count');
        formData.append('sections_url', window.location.pathname);
      }

      config.body = formData;
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      fetch(`${window.theme.routes.cart_add_url}`, config)
        .then((res) => res.json())
        .then((data) => {
          this.loading = false;
          this.addedToCart = true;

          if (modalCart) {
            document.body.dispatchEvent(
              new CustomEvent('shapes:modalcart:afteradditem', {
                bubbles: true,
                detail: { response: data },
              })
            );
          }

          if (!document.querySelector('[data-show-on-add="true"]')) {
            if (this.$refs.added) this.$nextTick(() => this.$refs.added.focus());
          }
        })
        .catch((error) => {
          error.json().then((a) => {
            this.loading = false;
            alert(a.description);
          });
        });
    }

    function buildNewListing(numListings, listingId, highClass, lowClass) {
      console.log(`build ${listingId}`)
      if (numListings > 1) {
        const highProduct = productContainer.querySelector(highClass);
        const lowProduct = productContainer.querySelector(lowClass);
        const listing = resultsContainer.querySelector(listingId);

        const pDriver = htmlToElem('<p class="text-xs text-center text-scheme-text uppercase">Driver Side</p>');
        const pPassenger = htmlToElem('<p class="text-xs text-center text-scheme-text uppercase">Passenger Side</p>');

        if (highProduct) {
          highProduct.prepend(pDriver);
          const highAddToCart = renderAddToCart(highProduct);
          highProduct.append(highAddToCart);
          listing.append(highProduct);
        }

        if (lowProduct) {
          lowProduct.prepend(pPassenger);
          const lowAddToCart = renderAddToCart(lowProduct);
          lowProduct.append(lowAddToCart);
          listing.append(lowProduct);
        }

        listing.parentNode.classList.remove('hidden');
      } else if (numListings > 0 && highClass && lowClass) {
        const highProduct = productContainer.querySelector(highClass);
        const lowProduct = productContainer.querySelector(lowClass);
        const listing = resultsContainer.querySelector(listingId);

        const pBoth = htmlToElem(
          '<p class="text-xs text-center text-scheme-text uppercase">Driver & Passenger Sides<br>Sold Individually</p>'
        );

        if (highProduct) {
          highProduct.prepend(pBoth);
          const highAddToCart = renderAddToCart(highProduct);
          highProduct.append(highAddToCart);
          listing.append(highProduct);
        }

        if (lowProduct) {
          lowProduct.prepend(pBoth);
          const lowAddToCart = renderAddToCart(lowProduct);
          lowProduct.append(lowAddToCart);
          listing.append(lowProduct);
        }

        listing.parentNode.classList.remove('hidden');
      } else if (numListings > 0 && !lowClass) {
        console.log(highClass);
        const highProduct = productContainer.querySelector(highClass);
        const listing = resultsContainer.querySelector(listingId);

        const highAddToCart = renderAddToCart(highProduct);
        highProduct.append(highAddToCart);

        listing.append(highProduct);

        listing.parentNode.classList.remove('hidden');
      }
    }

    products.forEach((product, index) => {
      const productTitle = product.querySelector('.grid-view-item__title a').innerText;
      let currentSize = 0;
      console.log(productTitle)
      
      switch (productTitle) {
        case productTitle.match('Platinum')?.input:
          num_platinum = num_platinum + 1;
          currentSize = parseInt(productTitle.match(/\d+/));
          if (currentSize > low_platinum) {
            low_platinum = currentSize;
            const currentHigh = productContainer.querySelector('.platinum_high');
            if (currentHigh) {
              currentHigh.classList.remove('platinum_high');
              currentHigh.classList.add('platinum_low');
            }
            product.classList.add('platinum_high');
          } else {
            product.classList.add('platinum_low');
          }
          break;

        case productTitle.match('Blue')?.input:
          num_shade_blue = num_shade_blue + 1;
          currentSize = parseInt(productTitle.match(/\d+/));
          if (currentSize > low_shade_blue) {
            low_shade_blue = currentSize;
            const currentHigh = productContainer.querySelector('.shade_high_blue');
            if (currentHigh) {
              currentHigh.classList.remove('shade_high_blue');
              currentHigh.classList.add('shade_low_blue');
            }
            product.classList.add('shade_high_blue');
          } else {
            product.classList.add('shade_low_blue');
          }
          break;

        case productTitle.match('Green')?.input:
          num_shade_green = num_shade_green + 1;
          currentSize = parseInt(productTitle.match(/\d+/));
          if (currentSize > low_shade_green) {
            low_shade_green = currentSize;
            const currentHigh = productContainer.querySelector('.shade_high_green');
            if (currentHigh) {
              currentHigh.classList.remove('shade_high_green');
              currentHigh.classList.add('shade_low_green');
            }
            product.classList.add('shade_high_green');
          } else {
            product.classList.add('shade_low_green');
          }
          break;

        case productTitle.match('Orange')?.input:
          num_shade_orange = num_shade_orange + 1;
          currentSize = parseInt(productTitle.match(/\d+/));
          if (currentSize > low_shade_orange) {
            low_shade_orange = currentSize;
            const currentHigh = productContainer.querySelector('.shade_high_orange');
            if (currentHigh) {
              currentHigh.classList.remove('shade_high_orange');
              currentHigh.classList.add('shade_low_orange');
            }
            product.classList.add('shade_high_orange');
          } else {
            product.classList.add('shade_low_orange');
          }
          break;

        case productTitle.match('Pink')?.input:
          num_shade_pink = num_shade_pink + 1;
          currentSize = parseInt(productTitle.match(/\d+/));
          if (currentSize > low_shade_pink) {
            low_shade_pink = currentSize;
            const currentHigh = productContainer.querySelector('.shade_high_pink');
            if (currentHigh) {
              currentHigh.classList.remove('shade_high_pink');
              currentHigh.classList.add('shade_low_pink');
            }
            product.classList.add('shade_high_pink');
          } else {
            product.classList.add('shade_low_pink');
          }
          break;

        case productTitle.match('Red')?.input:
          num_shade_red = num_shade_red + 1;
          currentSize = parseInt(productTitle.match(/\d+/));
          if (currentSize > low_shade_red) {
            low_shade_red = currentSize;
            const currentHigh = productContainer.querySelector('.shade_high_red');
            if (currentHigh) {
              currentHigh.classList.remove('shade_high_red');
              currentHigh.classList.add('shade_low_red');
            }
            product.classList.add('shade_high_red');
          } else {
            product.classList.add('shade_low_red');
          }
          break;

        case productTitle.match('White')?.input:
          num_shade_white = num_shade_white + 1;
          currentSize = parseInt(productTitle.match(/\d+/));
          if (currentSize > low_shade_white) {
            low_shade_white = currentSize;
            const currentHigh = productContainer.querySelector('.shade_high_white');
            if (currentHigh) {
              currentHigh.classList.remove('shade_high_white');
              currentHigh.classList.add('shade_low_white');
            }
            product.classList.add('shade_high_white');
          } else {
            product.classList.add('shade_low_white');
          }
          break;

        case productTitle.match('Black Edition')?.input:
          console.log("Matched Black Edition");
          num_black_edition = num_black_edition + 1;
          currentSize = parseInt(productTitle.match(/\d+/));
          if (currentSize > low_black_edition) {
            low_black_edition = currentSize;
            const currentHigh = productContainer.querySelector('.black_edition_high');
            if (currentHigh) {
              currentHigh.classList.remove('black_edition_high');
              currentHigh.classList.add('black_edition_low');
            }
            product.classList.add('black_edition_high');
          } else {
            product.classList.add('black_edition_low');
          }
          break;

        case productTitle.match('Rear')?.input:
          console.log('Matched Rear');
          num_rear = num_rear + 1;
          product.classList.add('rear_blade');
          break;

        default:
          num_heavy = num_heavy + 1;
          currentSize = parseInt(productTitle.match(/\d+/));
          if (currentSize > low_heavy) {
            low_heavy = currentSize;
            const currentHigh = productContainer.querySelector('.heavy_high');
            if (currentHigh) {
              currentHigh.classList.remove('heavy_high');
              currentHigh.classList.add('heavy_low');
            }
            product.classList.add('heavy_high');
          } else {
            product.classList.add('heavy_low');
          }
          break;
      }
    });

    buildNewListing(num_platinum, '#platinum', '.platinum_high', '.platinum_low');
    buildNewListing(num_shade_blue, '#shade_blue', '.shade_high_blue', '.shade_low_blue');
    buildNewListing(num_shade_green, '#shade_green', '.shade_high_green', '.shade_low_green');
    buildNewListing(num_shade_orange, '#shade_orange', '.shade_high_orange', '.shade_low_orange');
    buildNewListing(num_shade_pink, '#shade_pink', '.shade_high_pink', '.shade_low_pink');
    buildNewListing(num_shade_red, '#shade_red', '.shade_high_red', '.shade_low_red');
    buildNewListing(num_shade_white, '#shade_white', '.shade_high_white', '.shade_low_white');
    buildNewListing(num_black_edition, '#black_edition', '.black_edition_high', '.black_edition_low');
    buildNewListing(num_heavy, '#heavy_duty', '.heavy_high', '.heavy_low');
    buildNewListing(num_rear, '#rear', '.rear_blade', null);

    resultsContainer.querySelectorAll('[data-ymm-add-to-cart]').forEach((addToCartForm) => {
      addToCartForm.addEventListener('submit', handleAddToCart);
    });

    return true; // Indicate processing succeeded
  }

  // Set up observer to watch for products loading
  const productContainer = document.querySelector('#product_container');
  
  if (productContainer) {
    let hasProcessed = false;
    
    const observer = new MutationObserver((mutations) => {
      // Check if we haven't processed yet and products exist
      if (!hasProcessed && productContainer.querySelectorAll('.grid__item').length > 0) {
        console.log('Products detected, processing...');
        hasProcessed = processProducts();
        if (hasProcessed) {
          observer.disconnect(); // Stop observing once processed
        }
      }
    });

    // Start observing
    observer.observe(productContainer, {
      childList: true,
      subtree: true
    });

    // Also try processing immediately in case products are already loaded
    setTimeout(() => {
      if (!hasProcessed) {
        hasProcessed = processProducts();
        if (hasProcessed) {
          observer.disconnect();
        }
      }
    }, 100);
  }

  } catch(e) { console.error(e); }
})();
})();
